// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"094e8dec","72":"81ca3e96","216":"a78afdeb","398":"575d563e","637":"b56f1942","742":"133f6901","977":"4b058a94"}[chunkId] + ".chunk.css";
};